import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import * as PropTypes from 'prop-types';

import { SURVEYS_LIST_TYPE } from '../../../constants';
import { useLazyLoad } from '../../../hocs/useLazyLoad';
import { CommonTabs } from '../../common/CommonTabs';
import TodoList from '../Components/TodoList';
import { enhance } from './enhance';
import { usePageView } from '../../../hocs/usePageView';
import MetaHelmet from '../../AppHelmet/MetaHelmet';

function TodoListTabs({
  resetTab,
  defaultTab,
  scheduleTasks,
  scheduleTasksPending,
  scheduleTasksCount,
  fetchScheduledTasks,
  loadNextScheduledTasks,
  fetchCompletedTasks,
  completedTasks,
  completedTasksPending,
  completedTasksCount,
  loadNextCompletedTasks,
  id,
}) {
  const [activeTab, setActiveTab] = useState(
    defaultTab || SURVEYS_LIST_TYPE.UPCOMING,
  );
  const tabs = useTabs(scheduleTasksCount, completedTasksCount);
  const rootRef = useRef();
  const loadMore = useCallback(() => {
    if (activeTab === SURVEYS_LIST_TYPE.RESULTS) {
      loadNextCompletedTasks({ id, limit: 10 });
    }
    if (activeTab === SURVEYS_LIST_TYPE.UPCOMING) {
      loadNextScheduledTasks({ id });
    }
  }, [activeTab]);
  usePageView('Home | Todo List');
  useLazyLoad({ node: rootRef, loadMore, path: [] });
  useEffect(() => {
    fetchScheduledTasks({ id, limit: 20, offset: 0 });
    fetchCompletedTasks({ id, limit: 20, offset: 0 });
  }, []);

  useEffect(() => {
    return () => resetTab();
  }, []);

  const contentData = tab => {
    switch (tab) {
      case SURVEYS_LIST_TYPE.RESULTS:
        return {
          list: completedTasks,
          loading: completedTasksPending,
          isUpcoming: false,
        };
      case SURVEYS_LIST_TYPE.UPCOMING:
        return {
          list: scheduleTasks,
          loading: scheduleTasksPending,
          isUpcoming: true,
        };
      default:
        return null;
    }
  };

  return (
    <div styleName="root" ref={rootRef}>
      <MetaHelmet title="pages.title.homeTodos" />

      <div styleName="content">
        <CommonTabs
          onTabSelect={setActiveTab}
          activeTab={activeTab}
          tabList={tabs}
          renderContent={tab => <TodoList {...contentData(tab)} />}
        />
      </div>
    </div>
  );
}

TodoListTabs.propTypes = {
  intl: PropTypes.object,
  resetTab: PropTypes.func,
  scheduleTasks: PropTypes.array,
  scheduleTasksCount: PropTypes.number,
  scheduleTasksPending: PropTypes.bool,
  fetchScheduledTasks: PropTypes.func,
  loadNextScheduledTasks: PropTypes.func,
  fetchCompletedTasks: PropTypes.func,
  completedTasks: PropTypes.array,
  completedTasksPending: PropTypes.bool,
  completedTasksCount: PropTypes.number,
  loadNextCompletedTasks: PropTypes.func,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  defaultTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default enhance(TodoListTabs);

function useTabs(upcomingCounter, completedCounter) {
  return useMemo(
    () => [
      {
        label: 'general.todo',
        tab: SURVEYS_LIST_TYPE.UPCOMING,
        id: SURVEYS_LIST_TYPE.UPCOMING,
        counter: upcomingCounter,
      },
      {
        label: 'general.completed',
        tab: SURVEYS_LIST_TYPE.RESULTS,
        id: SURVEYS_LIST_TYPE.RESULTS,
        counter: completedCounter,
      },
    ],
    [upcomingCounter, completedCounter],
  );
}



// WEBPACK FOOTER //
// ./src/components/Healthboard/TodoListTabs/index.jsx